import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Her route degisiminde window scroll'u tepeye tasir.
 * AppRouter icinde <Routes>'tan once render edilir.
 * Hash navigation destekler: URL'de #section varsa o anchor'a scroll yapar.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'instant' });
      } else {
        window.scrollTo(0, 0);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
